import * as Yup from 'yup';

export const registrationSchema = Yup.object({
	firstName: Yup.string()
		.min(3, 'Must be 3 characters or more')
		.required('Required'),
	lastName: Yup.string()
		.min(3, 'Must be 3 characters or more')
		.required('Required'),
	email: Yup.string()
		.email('Please enter a valid email')
		.required('Required'),
	phoneNumber: Yup.string()
		.matches(/^[0-9]*$/, 'Must contain only numbers')
		.min(10, 'Must be at least 10 digits')
		.max(12, 'Must be at most 12 digits')
		.required('Required'),
	password: Yup.string()
		.min(6, 'Must be 6 characters or more')
		.matches(/^(?=.*[a-z])/, 'Must contain at least 1 lowercase letter')
		.matches(/^(?=.*[A-Z])/, 'Must contain at least 1 uppercase letter')
		.matches(/^(?=.*[0-9])/, 'Must contain at least 1 number')
		// eslint-disable-next-line no-useless-escape
		// .matches(/^(?=.*[!@#\$%\^&])/, 'Must contain at least 1 special character e.g (!@#$%^&)')
		.required('Required'),
	confirmPassword: Yup.string()
		.oneOf([Yup.ref('password'), null], 'Passwords must match')
		.required('Required')
});

export const loginSchema = Yup.object({
	email: Yup.string()
		.email('Please enter a valid email')
		.required('Required'),
	password: Yup.string()
		.required('Required')
})

export const addPasswordSchema = Yup.object({
	password: Yup.string()
		.min(6, 'Must be 6 characters or more')
		.matches(/^(?=.*[a-z])/, 'Must contain at least 1 lowercase letter')
		.matches(/^(?=.*[A-Z])/, 'Must contain at least 1 uppercase letter')
		.matches(/^(?=.*[0-9])/, 'Must contain at least 1 number')
		.required('Required'),
	confirmPassword: Yup.string()
		.oneOf([Yup.ref('password'), null], 'Passwords must match')
		.required('Required')
})

export const forgotPasswordSchema = Yup.object({
	email: Yup.string()
		.email('Please enter a valid email')
		.required('Required')
})
